import { DownsellStep } from "@redotech/redo-flows-common/steps";
import { t } from "@redotech/redo-i18n";
import { FrontendStepType, PartialWithRequiredType } from ".";
import { UpsellInspector } from "./inspectors/upsell-inspector";

export const downsellStepType: FrontendStepType<
  PartialWithRequiredType<DownsellStep>
> = {
  type: "standard",
  valid: (step) => true,
  inspectorFactory: (outerProps) => ({
    header: { title: outerProps.step.name ?? t("Downsell") },
    sections: [
      {
        fields: [
          { path: "name", label: t("Downsell name"), widget: "text" },
          {
            path: "downsellId",
            label: "",
            widget: "custom",
            Element: (props) => {
              return (
                <UpsellInspector
                  doSave={outerProps.save}
                  upsellId={props.value.downsellId ?? ""}
                />
              );
            },
          },
        ],
      },
    ],
  }),
};
